<template>
    <div class="row">
        <div class="form-group col-md-3">
            <label for="newQuestion" class="form-label">{{ _t('Question') }}</label>
            <input v-model="text" type="text" id="newQuestion" class="form-control"/>
        </div>
        <div class="form-group col-md-3">
            <label class="form-label">{{ _t('Question type') }}</label>

            <select v-model="type" class="form-control">
                <option disabled value="">{{ _t('Select...') }}</option>
                <option value="open">{{ _t('open') }}</option>
                <option value="number">{{ _t('number') }}</option>
                <option value="single_answer">{{ _t('single_answer') }}</option>
                <option value="multi_answer">{{ _t('multi_answer') }}</option>
            </select>
        </div>
        <div class="form-group col-md-3">
            <label class="form-label" for="sortOrder">{{ _t('Sort order') }}</label>

            <input v-model="sortOrder" class="form-control" type="number" id="sortOrder">
        </div>
        <div class="form-group col-md-3">
            <label class="form-label" for="isRequiredCheckbox">{{ _t('Required answer') }}</label>
            <input v-model="isRequired" class="checkbox" type="checkbox" id="isRequiredCheckbox">
        </div>
        <div class="form-group col-md-6">
            <label for="imageDesktop" class="form-label">Desktop image</label>
            <input class="form-control" type="file" id="imageDesktop"  @change="handleFileChange($event, 'desktop')" ref="fileInput">
            <div class="image-container">
                <button type="button" class="btn btn-danger delete" @click.prevent="handleDeleteImage('desktop')"><i class="glyphicon glyphicon-trash" ></i></button>
                <img :src="desktopImagePreview" class="img-fluid" v-if="desktopImagePreview">
            </div>
        </div>
        <div class="form-group col-md-6">
            <label for="imageMobile" class="form-label">Mobile image</label>
            <input class="form-control" type="file" id="imageMobile"  @change="handleFileChange($event, 'mobile')" ref="fileInputMobile">
            <div class="image-container">
                <button type="button" class="btn btn-danger delete" @click.prevent="handleDeleteImage('mobile')"><i class="glyphicon glyphicon-trash"></i></button>
                <img :src="mobileImagePreview" class="img-fluid" v-if="mobileImagePreview">
            </div>
        </div>


        <div class="form-group col-md-12">
            <button @click="handleUpdate" class="btn btn-success mt-3">
                <span>{{ _t('Save') }}</span>
            </button>
            <button class="btn btn-secondary" @click="handleCancel">{{ _t("Cancel") }}</button>
        </div>
    </div>
</template>

<script>
import Url from "blueimp-load-image";

export default {
    name: "EditQuestion",
    props: [
        'initialText',
        'initialType',
        'initialSortOrder',
        'initialIsRequired',
        'desktopImageUrl',
        'mobileImageUrl'
    ],
    data() {
        return {
            text: this.initialText,
            type: this.initialType,
            sortOrder: this.initialSortOrder,
            isRequired: this.initialIsRequired,
            desktopImage: false,
            desktopImagePreview: this.desktopImageUrl,
            mobileImage: false,
            mobileImagePreview: this.mobileImageUrl
        }
    },
    methods: {
        handleUpdate() {
            if (!this.text || !this.sortOrder === 0 || !this.type) {
                Swal.fire({
                    text: _t('Text, type and sort order fields are required'),
                    icon: "error",
                    duration: '1000'
                })
                return;
            }

            this.$emit('question-updated', {
                type: this.type,
                text: this.text,
                sort_order: this.sortOrder,
                is_required: this.isRequired,
                desktop_image: this.desktopImage,
                mobile_image: this.mobileImage,
            })
        },
        handleCancel() {
            this.reset()
            this.$emit('closed')
        },

        handleFileChange(event, size) {
            const field = `${size}Image`
            const previewUrl = field + 'Preview';
            this[field] = event.target.files[0];
            this[previewUrl] = Url.createObjectURL(event.target.files[0]);
            this.$forceUpdate();

        },

        handleDeleteImage(type)
        {
            this.$emit('delete-question-image', {type: type})
        },

        reset() {
            this.text = this.initialText;
            this.type = this.initialType;
            this.sortOrder = this.initialSortOrder;
            this.isRequired = this.initialIsRequired
        }
    }
}
</script>

<style scoped>
.image-container
{
    margin-top: 10px;
}

.delete
{
    position: absolute;
    right: 25px;
    top: 80px;
}

img {
    max-width: 100%;
}
</style>



// WEBPACK FOOTER //
// resources/js/app/components/EditQuestion.vue